import { defineComponent as r, openBlock as a, createBlock as l, unref as p, mergeProps as s, withCtx as c, createElementVNode as t } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const d = /* @__PURE__ */ r({
  name: "IconHistory",
  __name: "IconHistory",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const n = o;
    return (m, e) => (a(), l(p(i), s(n, { "view-box": "0 0 24 24" }), {
      default: c(() => [...e[0] || (e[0] = [
        t("path", { d: "M10.14 2.43c5.285-1.028 10.403 2.424 11.431 7.71s-2.425 10.404-7.71 11.431a9.74 9.74 0 0 1-9.13-3.07.75.75 0 0 1 1.117-1.001A8.25 8.25 0 1 0 5.13 7.434l-.033.05 1.88-.365a.75.75 0 0 1 .286 1.473L4.318 9.164a1.25 1.25 0 0 1-1.466-.989L2.184 4.74a.75.75 0 1 1 1.473-.286l.375 1.931a9.72 9.72 0 0 1 6.107-3.956" }, null, -1),
        t("path", { d: "M12 6.25A.75.75 0 0 1 12.75 7v4.69l2.78 2.78a.75.75 0 0 1-1.06 1.06l-2.854-2.853a1.25 1.25 0 0 1-.366-.884V7A.75.75 0 0 1 12 6.25" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  d as default
};
